/*
© Copyright 2021 Orolabs.ai to present
* All rights reserved.
* Unauthorized copying of this file, via any medium is strictly prohibited.
* Proprietary and confidential.
*/

import type { SVGProps } from "react"

const Copy = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props} fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 2C3.34315 2 2 3.34315 2 5V13C2 14.6569 3.34315 16 5 16H6V19C6 20.6569 7.34315 22 9 22H19C20.6569 22 22 20.6569 22 19V11C22 9.34315 20.6569 8 19 8H18V5C18 3.34315 16.6569 2 15 2H5ZM16 8V5C16 4.44772 15.5523 4 15 4H5C4.44772 4 4 4.44772 4 5V13C4 13.5523 4.44772 14 5 14H6V11C6 9.34315 7.34315 8 9 8H16ZM9 10C8.44772 10 8 10.4477 8 11V19C8 19.5523 8.44772 20 9 20H19C19.5523 20 20 19.5523 20 19V11C20 10.4477 19.5523 10 19 10H9Z"
      fill={props.fill || 'currentColor'}
    />
  </svg>
)

export default Copy
